function notificationName(notificationsConfig) {
    return function (notification) {
        var fn = notificationsConfig.NOTIFICATION_NAMES[notification.type] || function(notification) { return notification.type; };
        return fn(notification);
    };
}

export {notificationName}